/**
 * Color-coded badge for org tier (base/pro/premium/enterprise).
 */
export function TierBadge({ tier }: { tier: string }) {
  const className =
    tier === "enterprise"
      ? "bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300"
      : tier === "premium"
        ? "bg-indigo-100 text-indigo-700 dark:bg-indigo-900/30 dark:text-indigo-300"
        : tier === "pro"
          ? "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300"
          : "bg-gray-100 text-gray-500 dark:bg-gray-800 dark:text-gray-400";

  return (
    <span className={`text-[10px] px-1.5 py-0.5 rounded-full font-medium ${className}`}>
      {tier}
    </span>
  );
}
